import { Location, LocationState } from 'services/api/types';

const locations: Location[] = [
  {
    id: 1,
    state: LocationState.Active,
    country: 'Singapore',
    post_code: '068894',
    city: 'Singapore',
    delivery_instructions: 'Leave at 10 floor counter',
    campus: 'Afro Asia',
    building: '',
    latitude: 1.279247,
    longitude: 103.84906,
    floor: '10',
    room: '',
    address_other: '63 Robinson Road #11-01',
    address_line1: '63 Robinson Road',
    address_line2: '#11-01s',
    api_city_id: 5
  },
  {
    id: 2,
    state: LocationState.Suspended,
    country: 'Malaysia',
    post_code: '59200',
    city: 'Kuala Lumpur',
    delivery_instructions: '',
    campus: 'TThe Vertical Coporate Towers',
    building: 'Tower B',
    latitude: 1.279247,
    longitude: 103.84906,
    floor: '37',
    room: '37-01',
    address_other:
      'The Vertical Corporate Towers, Avenue 10, Bangsar South, No. 8, Jalan Kerinchi, 59200',
    address_line1:
      'The Vertical Corporate Towers, Avenue 10, Bangsar South, No. 8',
    address_line2: 'Jalan Kerinchi, 59200',
    api_city_id: 1
  },
  {
    id: 3,
    state: LocationState.Active,
    country: 'Thailand',
    post_code: '10110',
    city: 'Bangkok',
    delivery_instructions: '6th floor is the drop off',
    campus: 'O-NES Tower',
    building: 'O-NES Tower',
    latitude: 13.739776,
    longitude: 100.554718,
    floor: '37',
    room: '37-01',
    address_other:
      'No. 6, 11th and 12th floors, O-NES Tower, Soi Sukhumvit 6, Klongtoey Sub-district, Klongtoey District',
    address_line1: 'No. 6, 11th and 12th floors, O-NES Tower, Soi Sukhumvit 6',
    address_line2: 'Klongtoey Sub-district, Klongtoey District',
    api_city_id: 6
  }
];

export default locations;
